import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function getData() {
	return new Promise((resolve, reject) => {
		return apiClient
			.get('/dashboard')
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
